import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'form/:formTip',
    loadComponent: () => import('./form/form.component').then((m) => m.FormComponent),
  },
  {
    path: 'contact-form',
    children: [
      {
        path: 'landing/:type',
        loadComponent: () =>
          import('./form/contact-self-service-forms/landing-screen/landing-screen.component').then((m) => m.LandingScreenComponent),
      },
      {
        path: 'email-verification/:type',
        loadComponent: () =>
          import('./form/contact-self-service-forms/email-verification-screen/email-verification-screen.component').then(
            (m) => m.EmailVerificationScreenComponent
          ),
      },
      {
        path: 'registration',
        loadComponent: () =>
          import('./form/contact-self-service-forms/reg-update-screen/reg-update-screen.component').then((m) => m.RegUpdateScreenComponent),
      },
      {
        path: 'update',
        loadComponent: () =>
          import('./form/contact-self-service-forms/reg-update-screen/reg-update-screen.component').then((m) => m.RegUpdateScreenComponent),
      },
      {
        path: 'self-service-acknowledgment-screen',
        loadComponent: () =>
          import('./form/contact-self-service-forms/self-service-acknowlagement-screen/self-service-acknowlagement-screen.component').then(
            (m) => m.SelfServiceAcknowlagementScreenComponent
          ),
      },
      {
        path: 'self-service-expired',
        loadComponent: () =>
          import('./form/contact-self-service-forms/self-service-expiry-screen/self-service-expiry-screen.component').then(
            (m) => m.SelfServiceExpiryScreenComponent
          ),
      },
    ],
  },
  {
    path: 'acknowledgment-screen',
    loadComponent: () =>
      import('./form/acknowledgment-screen/acknowledgment-screen.component').then((m) => m.AcknowledgmentScreenComponent),
  },
  {
    path: 'page-not-found',
    loadComponent: () => import('./form/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
  },
  { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' },
];
